module.exports = __webpack_public_path__ + "img/icon-refresh.60e0ee2c.png";